import $ from 'jquery';
import qs from 'query-string';

const checkProductCoupon = (productId, productIds) => {
  if (productIds !== null) {
    for (let id = 0; id < productIds.length; id++) {
      if (parseInt(productIds[id], 10) === productId) {
        return true;
      }
    }
    return false;
  } else {
    return true;
  }
};

const fixBanner = () => {
  let parentwidth = $('.feature-wrapper').width() - 10;
  $(window).scroll(function () {
    if ($(window).scrollTop() > 190) {
      $('#rp-features-table').width(parentwidth);
    } else {
      $('#rp-features-table').css({ position: 'relative' });
      $('#rp-features-table').width(parentwidth);
    }
  });
};

const parseUrlForProductParams = (location) => {
  let industryParam = null;
  let packageParam = null;
  let couponParam = null;
  let cookiesAccepted = false;

  if (location?.search?.length > 0) {
    industryParam = qs.parse(location.search).industry ? qs.parse(location.search).industry : null;
    packageParam = qs.parse(location.search).package ? qs.parse(location.search).package : null;
    couponParam = qs.parse(location.search).coupon ? qs.parse(location.search).coupon : null;
    cookiesAccepted = qs.parse(location.search).cookiesAccepted
      ? qs.parse(location.search).cookiesAccepted
      : false;
  }
  return { industryParam, packageParam,  couponParam, cookiesAccepted };
};

const productSwitch = (value) => {
  let cartItem = null;
  switch (value.quoteServiceType) {
    case 'RPPRealEstate':
      cartItem = rppProduct(value);
      break;
    case 'ReportBundle':
      cartItem = reportBundleProduct(value);
      break;
    case 'Blockbrief':
      cartItem = blockbriefProduct(value);
      break;
    default:
      break;
  }
  return cartItem;
};

const rppProduct = (value) => {
  let cartItem = {
    configuration: {
      addons: [],
      geography: {
        national: false,
        states: []
      },
      industry: value.industry,
      number_of_users: 1,
      package: value.packageName,
      product_id: value.id
    },
    product_id: value.id
  };
  return cartItem;
};

const reportBundleProduct = (value) => {
  let cartItem = {
    configuration: {
      packageName: value.packageName,
      geography: {
        states: null
      },
      product_id: value.id
    },
    product_id: value.id
  };

  return cartItem;
};

const blockbriefProduct = (value) => {
  let cartItem = {
    configuration: {
      package: value.packageName,
      number_of_users: 1,
      product_id: value.id
    },
    product_id: value.id
  };

  return cartItem;
};

export { checkProductCoupon, fixBanner, parseUrlForProductParams, productSwitch };
